import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { Label } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { ServerValidatedLegacyBudget } from '@bingads-webui-campaign-react/xandr-campaign';
import { MinXandrDailyBudgetRangePerCurrency } from '@bingads-webui-campaign-legacy/common-grid-config/budget/get-budget-range';
import { getBidTitleDetails } from '@bingads-webui-campaign-react/wizard-shared-components';
import { isXandrDisplayAdsCampaign } from '@bingads-webui-campaign-react/constants';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { getConvertedCurrencyDealMinimumBid, getAccountExchangeRateFromLocalStorage } from '@bingads-webui-campaign-react/xandr-video-campaign-shared-components';

import { getCampaignStyles } from '../styles';

export const XandrBudgetAndBidStrategy = ({
  data, isPremiumStreaming,
}) => {
  const i18n = useContext(I18nContext);

  const classes = useDefaultStyles(getCampaignStyles);

  const serverContext = useContext(ServerContext);
  const { campaign, dealDetails } = data || {};

  const minBudget = useMemo(() => {
    if (dealDetails) {
      const exchangeRateMapping = getAccountExchangeRateFromLocalStorage(serverContext);
      const dealMinimumBid = getConvertedCurrencyDealMinimumBid(dealDetails.MinimumBid, dealDetails.Currency, serverContext.CurrentAccount.CurrencyCode, exchangeRateMapping.val);
      return Math.max(dealMinimumBid || 0, MinXandrDailyBudgetRangePerCurrency[serverContext.CurrentAccount.CurrencyCode]);
    }

    return MinXandrDailyBudgetRangePerCurrency[serverContext.CurrentAccount.CurrencyCode];
  }, [dealDetails, serverContext]);

  const topicForBidStrategy = useMemo(() => {
    if (isXandrDisplayAdsCampaign(campaign.CampaignSubType)) {
      return undefined;
    }

    if (isPremiumStreaming) {
      return 'pop_BA_PremiumStreaming_BidStrategy';
    }
    return 'pop_BA_VideoAds_BidStrategyType';
  }, [campaign.CampaignSubType, isPremiumStreaming]);

  return (
    <div className={classes.budgetContainer}>
      <ServerValidatedLegacyBudget
        className={classNames('budget', classes.budget)}
        campaignId={campaign && campaign.Id}
        validationDailyMinBudget={minBudget}
        hideBudgetMinRecommendation
        required
        validationProps={{
          data: { Budget: campaign && campaign.Budget },
        }}
        isCreation
        isPremiumStreaming={isPremiumStreaming}
      />
      <span className="bid-strategy-type">
        <Label>
          {i18n.getString(_TL_('Bid strategy'))}
          <HelpPopup
            topic={topicForBidStrategy}
            aria-label={i18n.getString(_TL_('Click to learn more about bid strategy'))}
          />
        </Label>
        {getBidTitleDetails(i18n, campaign.BiddingScheme)}
      </span>
    </div>

  );
};
